export class ApplicantEvent {
  occurredOn: Date;
  
  constructor(public applicantEventType: string, public jobId: number, occurredOn: Date, public sessionId: string) {
    this.occurredOn = occurredOn;
  }
}

